import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { walldata } from '../Config/wallcoveringviewalldata';
import WallCards from "../Components/wallcoveringviewallCards";
import AddToWishlistButton from "../Components/AddToWishlistButton";

const WallcoveringViewallMobile = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-2 sm:px-5">
      <div className='services__area pt-10 hidden sm:block' id='services'>
        {/* <h2 className='text-2xl font-serif pl-20 pb-10 underline'>Wallcovering Wallpapers</h2> */}
      </div>

      <div className='grid grid-cols-2 gap-2 max-[640px]:grid-cols-2 max-[640px]:px-0 justify-items-center'> 
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div className="w-full max-[640px]:px-1 relative" key={index} ref={(el) => { if (el) cardRefs.current[index] = el; }}> 
            <Link to={`/wallcoverings/desc/${index + 1}`}>
              <WallCards 
                ImgSrc={it.Img} 
                ImgJpg={it.ImgJpg}
                ImgJpeg={it.ImgJpeg}
                title={it.title} 
                // desc={it.desc} 
                btn={it.btn}
                isDesktop={false}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
}

const WallcoveringViewallTablet = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-3 pt-10">
      <div className='services__area hidden sm:block' id='services'>
        {/* <h2 className='text-xl font-serif pl-10 pb-6 underline'>Wallcovering Wallpapers</h2> */}
      </div>

      <div className='grid grid-cols-2 gap-3 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div className="w-full max-w-[160px] relative" key={index} ref={(el) => { if (el) cardRefs.current[index] = el; }}>
            <Link to={`/wallcoverings/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                ImgJpeg={it.ImgJpeg}
                title={it.title}
                // desc={it.desc}
                btn={it.btn}
                isDesktop={false}
              />
            </Link>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

const WallcoveringViewallLaptop = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden p-0 sm:p-5 pt-20">
      <div className='services__area pt-10 hidden sm:block' id='services'>
        {/* <h2 className='text-xl font-serif pl-20 pb-10 underline'>Wallcovering Wallpapers</h2> */}
      </div>

      {/* Adjusted grid gap and max-width */}
      <div className='grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center max-w-[1400px] mx-auto px-4'> 
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div className="w-full sm:w-auto relative" key={index} ref={(el) => { if (el) cardRefs.current[index] = el; }}> 
            <Link to={`/wallcoverings/desc/${index + 1}`}>
              <WallCards 
                ImgSrc={it.Img} 
                ImgJpg={it.ImgJpg}
                ImgJpeg={it.ImgJpeg}
                title={it.title} 
                // desc={it.desc} 
                btn={it.btn}
                isDesktop={true}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
}

const WallcoveringViewallMidDesktop = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-4 pt-14">
      <div className='services__area hidden sm:block' id='services'>
        {/* <h2 className='text-xl font-serif pl-12 pb-8 underline'>Wallcoverings</h2> */}
      </div>

      <div className='grid grid-cols-3 gap-4 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div className="w-full max-w-[260px] relative" key={index} ref={(el) => { if (el) cardRefs.current[index] = el; }}>
            <Link to={`/wallcoverings/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                ImgJpeg={it.ImgJpeg}
                title={it.title}
                // desc={it.desc}
                btn={it.btn}
                isDesktop={false}
                customStyle="w-full h-[180px] object-cover scale-105"
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};


const WallcoveringViewall = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const scrollToId = searchParams.get('scrollTo');
  
  console.log('[WallcoveringViewAll] Component rendered - scrollToId from URL:', scrollToId, 'Full URL:', location.pathname + location.search);
  
  // Always prioritize sessionStorage over URL parameter (sessionStorage has the latest viewed image)
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    const lastViewedId = sessionStorage.getItem('lastViewedImageIdWallcoveringviewall');
    
    console.log('[WallcoveringViewAll] Checking - scrollToId in URL:', currentScrollToId, 'lastViewedId in storage:', lastViewedId);
    
    // Always prioritize sessionStorage if it exists (it has the most recent viewed image)
    if (lastViewedId) {
      // If URL has a different scrollToId than sessionStorage, update URL to use sessionStorage value
      if (currentScrollToId !== lastViewedId) {
        console.log('[WallcoveringViewAll] sessionStorage has different value than URL. Updating URL to use latest:', lastViewedId);
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set('scrollTo', lastViewedId);
        navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
        // Clear sessionStorage after using it
        sessionStorage.removeItem('lastViewedImageIdWallcoveringviewall');
        console.log('[WallcoveringViewAll] Updated URL with scrollTo from sessionStorage and cleared sessionStorage');
      } else {
        // They match, so clear sessionStorage to avoid conflicts
        console.log('[WallcoveringViewAll] URL and sessionStorage match, clearing sessionStorage');
        sessionStorage.removeItem('lastViewedImageIdWallcoveringviewall');
      }
    } else if (currentScrollToId) {
      // No sessionStorage but URL has scrollToId - this is fine, just log it
      console.log('[WallcoveringViewAll] Using scrollToId from URL:', currentScrollToId);
    } else {
      // Neither exists - normal navigation without scroll
      console.log('[WallcoveringViewAll] No scrollToId in URL and no lastViewedId in storage');
    }
  }, [location.pathname, location.search, navigate]);
  
  const [screenType, setScreenType] = useState('mobile');
  const [visibleItems, setVisibleItems] = useState(20);
  const [hasScrolledToTarget, setHasScrolledToTarget] = useState(false);

  // Reset scroll state when scrollToId changes
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    if (currentScrollToId) {
      console.log('[WallcoveringViewAll] scrollToId changed, resetting hasScrolledToTarget');
      setHasScrolledToTarget(false);
    }
  }, [location.search]);

  const observer = useRef();
  const cardRefs = useRef({});

  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    console.log('[WallcoveringViewAll] Scroll effect triggered - scrollToId:', currentScrollToId, 'hasScrolledToTarget:', hasScrolledToTarget, 'visibleItems:', visibleItems);
    
    if (currentScrollToId && !hasScrolledToTarget) {
      const targetIndex = parseInt(currentScrollToId) - 1;
      console.log('[WallcoveringViewAll] Target index calculated:', targetIndex, 'from scrollToId:', currentScrollToId);
      
      if (targetIndex >= visibleItems) {
        const newVisibleItems = Math.max(visibleItems, targetIndex + 10);
        console.log('[WallcoveringViewAll] Not enough items loaded. Current:', visibleItems, 'Target index:', targetIndex, 'Loading more:', newVisibleItems);
        setVisibleItems(newVisibleItems);
        return;
      }

      const attemptScroll = (attempt = 1) => {
        console.log(`[WallcoveringViewAll] Attempt ${attempt} to scroll to index:`, targetIndex);
        const targetElement = cardRefs.current[targetIndex];
        console.log('[WallcoveringViewAll] Target element found:', !!targetElement);
        
        if (targetElement) {
          console.log('[WallcoveringViewAll] Scrolling to element');
          targetElement.scrollIntoView({ 
            behavior: 'auto', 
            block: 'center' 
          });
          setHasScrolledToTarget(true);
          console.log('[WallcoveringViewAll] Scroll completed successfully');
          return true;
        }
        console.log('[WallcoveringViewAll] Target element not found, will retry');
        return false;
      };

      const timer1 = setTimeout(() => {
        console.log('[WallcoveringViewAll] First scroll attempt');
        if (!attemptScroll(1)) {
          setTimeout(() => {
            console.log('[WallcoveringViewAll] Second scroll attempt');
            if (!attemptScroll(2)) {
              setTimeout(() => {
                console.log('[WallcoveringViewAll] Third scroll attempt');
                if (!attemptScroll(3)) {
                  setTimeout(() => {
                    console.log('[WallcoveringViewAll] Final scroll attempt');
                    attemptScroll(4);
                  }, 200);
                }
              }, 200);
            }
          }, 200);
        }
      }, 200);
      
      return () => {
        console.log('[WallcoveringViewAll] Cleaning up scroll timeout');
        clearTimeout(timer1);
      };
    }
  }, [location.search, hasScrolledToTarget, visibleItems]);

  const lastCardRef = useCallback(node => {
    if (observer.current) {
      observer.current.disconnect();
    }

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && visibleItems < walldata.length) {
        setVisibleItems(prevItems => Math.min(prevItems + 20, walldata.length));
      }
    }, {
      rootMargin: '400px 0px',
    });

    if (node) {
      observer.current.observe(node);
    }
  }, [visibleItems]);

  useEffect(() => {
  const updateScreenType = () => {
    const width = window.innerWidth;
    if (width <= 635) {
      setScreenType('mobile');
    } else if (width >= 636 && width <= 788) {
      setScreenType('tablet');
    } else if (width >= 1020 && width <= 1244) {
      setScreenType('midDesktop');
    } else {
      setScreenType('laptop');
    }
  };

  updateScreenType();
  window.addEventListener('resize', updateScreenType);
  return () => window.removeEventListener('resize', updateScreenType);
}, []);

  if (screenType === 'midDesktop') return <WallcoveringViewallMidDesktop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  if (screenType === 'tablet') return <WallcoveringViewallTablet visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  if (screenType === 'laptop') return <WallcoveringViewallLaptop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  return <WallcoveringViewallMobile visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
};

export default WallcoveringViewall;
